import Typography from '../../components/ui/Typography';
import { MapToTextPropsModel } from '../../models/map-to-text-props.model';
import { TextToColorMapModel } from '../../models/text-to-color-map.model';
import { castTo } from '../cast-to';

export const MapToText = <Key, Value extends TextToColorMapModel>(
  props: MapToTextPropsModel<Key, Value>
): JSX.Element => {
  const { textColor, textContent } =
    (props.map.get(castTo<Key>(props.property)) as TextToColorMapModel) || {};

  return (
    <Typography
      component={'span'}
      sx={{
        fontWeight: 300,
        letterSpacing: 0,
        lineHeight: '17px',
        color: textColor,
        fontSize: props.fontSize ?? '16px',
        ...(props.sx ?? {}),
      }}
    >
      {textContent}
    </Typography>
  );
};
